<template>
  <div class="mk-autoweb-tab-right">
    <div class="w1200">
      <div class="subject-component-title center">{{ element.titleBarName }}</div>
      <div
        class="subject-component-desc center">{{ element.titleBarDesc }}</div>
      <div class="mk-autoweb-tab-right-content">
        <div class="mk-autoweb-tab-right-content-left">
          <ul>
            <li :key="index" v-for="(item, index) in childItem.propsValue.data">
              <div class="animate_top">
                <div class="tabRight-left-content" >
                  <div :key="index_child" v-for="(item_child, index_child) in item.customField4">
                    <div class="line"></div>
                    <img :src="item_child.customField5" alt />
                    <h5>{{ item_child.customField6 }}</h5>
                    <div>{{ item_child.customField7 }}</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="mk-autoweb-tab-right-content-right">
          <ul>
            <li :class="index == 0 ? 'on' : ''" :key="index" v-for="(item, index) in childItem.propsValue.data">
              <span>{{ item.customField1 }}</span>
              <div class="index_box">
                <a class="under_line">
                  <h4>{{ item.customField1 }}</h4>
                </a>
                <p>{{ item.customField2 }}</p>
                <a>
                  <button>{{ item.customField3.text }}</button>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkTabRightWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField4",
          label: "特点",
          type: "list",
          children: [
            {
              code: "customField5",
              label: "logo",
              type: "image",
              width: 50,
              height: 50
            },
            {
              code: "customField6",
              label: "标题",
              type: "text"
            },
            {
              code: "customField7",
              label: "描述",
              type: "text"
            }
          ]
        }
      ],
      data: [
        {
          customField1: "财务云",
          customField2:
            "财务云采用最新的大智物移云的技术，基于事项法会计理论，以业务事项为基础，实时会计、智能财务、精准税务、敏捷财资为核心理念，构建财务会计、管理会计、税务服务、报账服务、财资服务、企业绩效、电子档案服务、共享服务的全新一代财务体系。打造具备实时、智能、精细、多维、可视、生态的全球领先企业数智化财务云服务平台，助力企业财务数字化转型。",
          customField3: {
            afterClick: {
              contentId: "",
              contentImage: "",
              contentName: "",
              contentType: "data",
              type: 1,
              url: ""
            },
            beforeClick: {
              form: "",
              formtime: "一天",
              type: 0
            },
            text: "了解更多"
          },
          customField4: [
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "实时会计",
              customField7:
                "业务发生后实时执行财务会计与管理会计的多核算目的核算，实时财务报表与管理分析"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "精准税务",
              customField7:
                "以业财税金一体化、全流程应用，全税种管理与核算，税企直连自动化和税务风险评估为核心的创新应用"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "智能财务",
              customField7:
                "全面采用图像识别、语音识别、机器学习、RPA、VPA等各种智能技术，提升财务运营效率。"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "敏捷财资",
              customField7:
                "以企业现金流活动管理闭环为主线，提供企业流动性、资本运营、投融资和风险管理"
            }
          ]
        },
        {
          customField1: "人力云",
          customField2:
            "人力云定位大中型企业数字化人力资源平台。基于YonBIP商业创新平台，以赋能员工、激活组织为产品理念，运用连接、智慧、体验、开放的数字化要素引领组织人力资源数字化转型。实现组织人力运营成本降低，员工创造力提升，推动组织变革与战略目标的达成，快速适应复杂多变的外部状况。",
          customField3: {
            afterClick: {
              contentId: "",
              contentImage: "",
              contentName: "",
              contentType: "data",
              type: 1,
              url: ""
            },
            beforeClick: {
              form: "",
              formtime: "一天",
              type: 0
            },
            text: "了解更多"
          },
          customField4: [
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "网络连接",
              customField7:
                "连接供方、需方、人员、商品等一切对象，构建便捷的社会化商业网络"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "高效协同",
              customField7:
                "与供方进行战略寻源、采购到支付、超市化采购、废旧物资处置"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "生态共创",
              customField7:
                "同电商、物流商、金融服务商、企业信息服务商等多方生态合作，共同创造多样化的场景服务"
            },
            {
              customField5:
                "https://mks.yybip.com/group1/M00/01/E1/CgoRDGRZuj6AKKhMAABAvvYHo7c018.png",
              customField6: "商业创新",
              customField7:
                "基于云计算、大数据、人工智能等新技术，赋能上下游，快速实现交易、商务、物流"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-autoweb-tab-right {
  width: 100%;
  min-height: 520px;
}

.mk-autoweb-tab-right .subject-component-title {
  text-align: center;
  padding-top: 22px;
  font-size: 22px;
  line-height: 58px;
  color: #e31924;
}

.mk-autoweb-tab-right .subject-component-desc {
  text-align: center;
  color: #6f6f6f;
  font-size: 16px;
  line-height: 30px;
}

.mk-autoweb-tab-right .mk-autoweb-tab-right-content {
  width: 100%;
  height: 100%;
  min-height: 380px;
  margin: 22px 0;
  position: relative;
  display: flex;
}

.mk-autoweb-tab-right-content-left {
  width: 680px;
  margin-top: 0px;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content {
  width: 100%;
  overflow: hidden;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content > div {
  float: left;
  width: 285px;
  height: 145px;
  margin: 22px 0px 22px 22px;
  padding-left: 22px;
  padding-top: 0px;
}

.mk-autoweb-tab-right-content-left
  .tabRight-left-content
  > div:nth-of-type(even) {
  border-left: 1px solid #d0d0d0;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content > div .line {
  width: 100%;
  height: 1px;
  margin-top: -22px;
  background-color: #d0d0d0;
}

.mk-autoweb-tab-right-content-left
  .tabRight-left-content
  > div:nth-child(1)
  .line {
  display: none;
}

.mk-autoweb-tab-right-content-left
  .tabRight-left-content
  > div:nth-child(2)
  .line {
  display: none;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content > div h5 {
  font-size: 14px;
  line-height: 36px;
  color: #fa0000;
  text-shadow: 0px 0px 14px rgba(0, 0, 0, 0.08);
  font-weight: 600;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content > div img {
  width: 36px;
  height: 36px;
  margin-top: 22px;
}

.mk-autoweb-tab-right-content-left .tabRight-left-content > div div {
  line-height: 18px;
  color: #6f6f6f;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 10px;
}

.mk-autoweb-tab-right-content-right {
  width: 194px;
  text-align: center;
  padding-top: 0px;
}

.mk-autoweb-tab-right-content-right span {
  width: 194px;
  height: 40px;
  line-height: 40px;
  display: inline-table;
  cursor: pointer;
}

.mk-autoweb-tab-right-content-right h4 {
  text-align: left;
  font-size: 13px;
  color: #ffffff;
}

.mk-autoweb-tab-right-content-right li {
  height: 40px;
  background: #fff8f8;
  border-bottom: 1px solid #f1f1f1;
}

.mk-autoweb-tab-right-content-right li.on {
  height: 140px;
}

.mk-autoweb-tab-right-content-right li.on span {
  color: #fff;
  display: none;
}

.mk-autoweb-tab-right-content-right li.on .index_box {
  display: block !important;
}

.mk-autoweb-tab-right-content-right li.on .under_line {
  text-decoration: none;
}

.mk-autoweb-tab-right-content-right li.on .under_line:hover {
  text-decoration: underline;
  color: #ffffff;
}

.mk-autoweb-tab-right-content-right li .index_box {
  background: #e14c46;
  padding: 15px 19px;
  display: none;
}

.mk-autoweb-tab-right-content-right li .index_box p {
  color: #ffffff;
  font-size: 12px;
  margin-top: 8px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.mk-autoweb-tab-right-content-right li .index_box button {
  margin-left: -76px;
  margin-top: 12px;
  width: 78px;
  height: 26px;
  background: #ffffff;
  border-radius: 3px;
  font-size: 12px;
  color: #e14c46;
  border: none;
}
</style>
